import { EventBus } from "../../event-bus";
import { listService } from "../../services/ListService";
import { ownerService } from "../../services/OwnerService";

import EditAddress from "./../Common/editAddress.vue";

import { VueAutosuggest } from "vue-autosuggest";
import Multiselect from "vue-multiselect";
import { Switch as cSwitch } from "@coreui/vue";
import {
    required,
    requiredUnless,
    minLength,
    maxLength,
    email,
    numeric
} from "vuelidate/lib/validators";

import { mapGetters, mapMutations } from "vuex";

function validateCNP(value) {
    var re = /^\d{1}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-9]\d| 5[0-2]|99)\d{4}$/, //var re = /^\d{1}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d| 5[0-2]|99)\d{4}$/,
        bigSum = 0,
        rest = 0,
        ctrlDigit = 0,
        control = "279146358279",
        i = 0;
    if (re.test(value)) {
        for (i = 0; i < 12; i++) {
            bigSum += value[i] * control[i];
        }
        ctrlDigit = bigSum % 11;
        if (ctrlDigit === 10) {
            ctrlDigit = 1;
        }

        if (ctrlDigit !== parseInt(value[12], 10)) {
            return false;
        } else {
            return true;
        }
    }
    return false;
}

export default {
    name: "EditPerson",

    components: {
        Multiselect,
        cSwitch,
        EditAddress,
        VueAutosuggest
    },
    props: {},

    data() {
        return {
            loading: true,
            loadingOwners: false,
            //
            person: {},
            //

            leasingCompany: null,
            leasingCompanies: [], // Filled on created()

            driverLicenceYears: [], // Filled on created()
            driverLicenceMonths: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ],
            drivingLicenceDateCrossValidated: true,

            //CNP search
            ownerSuggestions: [],
            debounceMilliseconds: 5000,
            timeout: null,
            inputProps: {
                id: "autosuggest__input",
                placeholder: "cauta dupa cnp...",
                class: "form-control",
                name: "uniqueId",
                autocomplete: "off", // google should not propose autofill this textbox
                disabled: false,
                type: "number"
            },
            sectionConfigs: {
                owners: {
                    limit: 10,
                    label: "Proprietari",
                    onSelected: selected => {
                        this.person = selected.item;
                        this.getPersonLastAddress(this.person.Id);

                        // check if this user hads a car
                        EventBus.$emit("owner_selected", selected.item.Id, 0); // person ID , owner type
                    }
                }
            }
        };
    },

    validations: {
        person: {
            UniqueId: {
                required,
                numeric,
                minLength: minLength(13),
                maxLength: maxLength(13),
                validateCNP
            },
            LastName: {
                required
            },
            FirstName: {
                required
            },
            Phone: {
                required
            },
            Email: {
                required,
                email
            },
            IdCard: {
                required
            }
            //DrivingLicenseMonth: {
            //    required: requiredUnless('drivingLicenseIsOptional')
            //},
            //DrivingLicenseYear: {
            //    required: requiredUnless('drivingLicenseIsOptional')
            //},
        },
        leasingCompany: {
            required: requiredUnless("leasingCompanyIsOptional")
        }
    },

    computed: {
        ...mapGetters({
            // general
            appSettings: "general/appSettings",
            userSettings: "general/userSettings",

            orderTypeSettings: "general/orderTypeSettings",
            orderTypeSettingsLoaded: "general/orderTypeSettingsLoaded",
            settingsLoaded: "general/settingsLoaded",

            typeSettings: "general/typeSettings",

            // order
            order: "order/order",
            orderEditable: "order/orderEditable",
            owner: "order/owner",
            orderPerson: "order/person",
            vehicleOptions: "order/vehicleOptions"
        }),
        //
        isValid() {
            return !this.$v.$error;
        },
        personUniqueIdIsInvalid() {
            return this.$v.person.UniqueId.$anyError;
        },
        leasingCompanyIsInvalid() {
            return this.$v.leasingCompany.$anyError;
        },
        //
        leasingCompanyIsOptional() {
            return !this.owner.IsLeasing;
        },
        drivingLicenseIsOptional() {
            return this.order.OrderTypeId != 1; // RCA
        }
    },

    created() {
        EventBus.$on("ownerData_updated", this.loadPersonData);

        var model = this;
        if (this.vehicleOptions != null) {
            this.loadLeasingCompanies().then(() => {
                model.leasingCompany = this.leasingCompanies.find(
                    item => item.Code == this.owner.LeasingCompany
                );
            });
        }

        this.driverLicenceYears = listService.getDriverLicenceYears();

        this.person = JSON.parse(JSON.stringify(this.orderPerson));
        // Configure the CNP search control
        this.inputProps.disabled = !this.orderEditable;
    },

    methods: {
        ...mapMutations({
            setPersonToOrder: "order/setPerson",
            setLeasingCompany: "order/setLeasingCompany"
        }),
        //
        validate: function() {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            var valid = this.isValid && this.$refs.personAddress.validate();

            if (this.order.OrderTypeId == 1) {
                valid = valid && this.crossCheckCNPAndDrivingLicence();
            }

            return valid;
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid;
        },

        loadPersonData: function() {
            // load person
            this.person = JSON.parse(JSON.stringify(this.orderPerson));
            //load address
            this.$refs.personAddress.loadAddress();
        },

        //#region leasing
        leasingCompany_changed(value) {
            console.log("leasingCompany_changed");
            this.leasingCompany = value;
            this.setLeasingCompany(value);
        },
        leasingSelected(checked) {
            if (!checked) {
                this.leasingCompany = null;
                this.setLeasingCompany(null);
            }
        },
        loadLeasingCompanies() {
            var model = this;

            var promise = listService
                .getLeasingCompanies()
                .then(response => {
                    model.leasingCompanies = response.data;
                })
                .catch(e => {
                    showErrorNotification(e);
                });
            return promise;
        },
        //#endregion

        //#region CNP
        // CNP search
        fetchOwnerSugestions(val) {
            var model = this;

            //reset timer if new change before timeout
            clearTimeout(this.timeoutObj);

            this.timeoutObj = setTimeout(() => {
                if (val.length > 2) {
                    model.loadingOwners = true;
                    ownerService.getListByUniqueKey(val, 0).then(response => {
                        model.ownerSuggestions = [];
                        model.ownerSuggestions.push({
                            name: "owners",
                            data: response.data
                        });

                        model.loadingOwners = false;
                    });
                }
            }, 600);
        },
        getPersonLastAddress(id) {
            var model = this;
            ownerService.getPersonLastAddress(id).then(response => {
                var address = response.data;
                address.Id = 0; // reset the address .. will be saved as new address
                model.$refs.personAddress.setPersonAddress(address);
            });
        },

        getSuggestionValue(suggestion) {
            return suggestion.item.UniqueId;
        },
        // CNP search end

        crossCheckCNPAndDrivingLicence() {
            if (
                this.person.DrivingLicenseYear == null ||
                this.person.DrivingLicenseMonth == null
            ) {
                this.drivingLicenceDateCrossValidated = false;
                return false;
            }

            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            var yearFromCNP = parseInt(this.person.UniqueId.substring(1, 3));
            var monthFromCNP = parseInt(this.person.UniqueId.substring(3, 5));

            if (yearFromCNP > currentYear - 2000)
                yearFromCNP = 1900 + yearFromCNP;
            else yearFromCNP = 2000 + yearFromCNP;
            //

            var yearFromDL = parseInt(this.person.DrivingLicenseYear);
            var monthFromDL = parseInt(this.person.DrivingLicenseMonth);
            //
            var eighteenYearsDate = new Date(yearFromCNP + 18, monthFromCNP, 1);
            var drivingLicenceDate = new Date(yearFromDL, monthFromDL, 1);
            //
            this.drivingLicenceDateCrossValidated =
                eighteenYearsDate < drivingLicenceDate;

            return this.drivingLicenceDateCrossValidated;
        }
        //#endregion
    },

    watch: {
        person: {
            handler: function(val, oldVal) {
                this.setPersonToOrder(val);
            },
            deep: true
        }
    },

    beforeDestroy() {
        EventBus.$off("ownerData_updated", this.loadPersonData);
    }
};
